import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { CheckBoxComponent } from './checkbox.component';

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [CheckBoxComponent],
    exports: [CheckBoxComponent],
    providers: []
})
export class CheckBoxModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/checkbox/checkbox.module.ts